module.exports = "/assets/d501b44e811239ac691bbbe377fbbd3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/DD.png
// module id = 2424
// module chunks = 0